import { useEffect, useRef } from 'react';
import { useQueryClient } from 'react-query';
import { connectMessageStream } from '../apiClient';
import {
  MESSAGE_THREADS_KEY,
  MESSAGE_UNREAD_KEY,
  messageThreadKey,
  messageThreadMessagesKey,
} from './queryKeys';

export function useMessageStream({ enabled = true } = {}) {
  const queryClient = useQueryClient();
  const abortRef = useRef(null);

  useEffect(() => {
    if (!enabled) return undefined;

    const controller = new AbortController();
    abortRef.current = controller;

    connectMessageStream({
      signal: controller.signal,
      onEvent: (event, data) => {
        if (event === 'message' && data?.threadId) {
          queryClient.invalidateQueries(messageThreadMessagesKey(data.threadId));
          queryClient.invalidateQueries(messageThreadKey(data.threadId));
        }

        if (event === 'threads_changed' || event === 'message') {
          queryClient.invalidateQueries([MESSAGE_THREADS_KEY]);
        }

        if (event === 'unread_count') {
          queryClient.setQueryData([MESSAGE_UNREAD_KEY], { data: { unreadCount: data.unreadCount } });
        } else if (event === 'message' || event === 'threads_changed') {
          queryClient.invalidateQueries([MESSAGE_UNREAD_KEY]);
        }
      },
    }).catch((error) => {
      if (error.name !== 'AbortError') {
        console.warn('Message stream disconnected:', error.message);
      }
    });

    return () => {
      controller.abort();
      abortRef.current = null;
    };
  }, [enabled, queryClient]);
}
